var USER_STATE = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};
export default (function (user) {
  return user.state === USER_STATE.ACTIVE;
});
//# sourceMappingURL=isUserActive.js.map